import { Link } from "react-router-dom";
import { Car, Facebook, Twitter, Instagram, Linkedin, ShieldCheck } from "lucide-react";

const COLS = [
  { title: "Services", links: [["Local Taxi", "/search"], ["Airport Transfers", "/airport-transfers"], ["Station Transfers", "/station-transfers"], ["Outstation", "/outstation"], ["Tourist Travel", "/tourist"], ["Corporate Travel", "/corporate"]] },
  { title: "Popular Locations", links: [["London", "/search"], ["Manchester", "/search"], ["Birmingham", "/search"], ["Leeds", "/search"], ["Liverpool", "/search"], ["Edinburgh", "/search"]] },
  { title: "Company", links: [["About", "/help"], ["Become a Driver", "/become-a-driver"], ["Corporate", "/corporate"], ["Contact", "/help"], ["Help Centre", "/help"]] },
  { title: "Legal", links: [["Terms", "/help"], ["Privacy", "/help"], ["Cookie Policy", "/help"], ["Cancellation Policy", "/help"]] },
];

export function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-800 bg-navy text-slate-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-5">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand text-white"><Car size={18} /></span>
              <span className="font-heading text-lg font-bold text-white">SmartFares<span className="text-brand">4U</span></span>
            </Link>
            <p className="mt-4 text-sm text-slate-400 max-w-xs">Your Ride. Your Fare. Your Journey. Book trusted taxis across the UK — locally, from airports and stations, or for longer journeys.</p>
            <div className="mt-5 flex gap-3">
              {[Facebook, Twitter, Instagram, Linkedin].map((I, i) => (
                <a key={i} href="#" className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 hover:bg-brand transition" aria-label="social"><I size={16} /></a>
              ))}
            </div>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="font-heading text-sm font-semibold text-white">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-slate-400 hover:text-white transition">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-slate-800 pt-6 sm:flex-row">
          <p className="text-xs text-slate-500">© 2026 SmartFares4U. All rights reserved.</p>
          <p className="flex items-center gap-2 text-xs text-slate-500"><ShieldCheck size={14} className="text-emerald-400" /> Secure booking · Verified taxi partners</p>
        </div>
      </div>
    </footer>
  );
}
